module.exports = __webpack_public_path__ + "static/media/youtube-icon-newpurple.6d3a1f1a.svg";